import { createRoot } from 'react-dom/client';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { returnString } from './utils/environmentVariables';
import { datadogRum } from '@datadog/browser-rum';
import { App } from 'src/app';
import Intercom from './components/intercom';
import { AuthProvider } from './routes/AuthContext';
import { setJotformCookies } from './utils/setJotformCookies';
import { Provider as ReduxProvider } from 'react-redux';
import { persistor, reduxStore } from './redux/store';
import { PersistGate as ReduxPersist } from 'redux-persist/lib/integration/react';
import { init as initFullStory } from '@fullstory/browser';
import { FullStory as FS } from '@fullstory/browser';

if (window.location.hostname !== 'localhost') {
  setJotformCookies();
}

const root = createRoot(document.getElementById('root') as HTMLElement);

datadogRum.init({
  applicationId: returnString(import.meta.env.VITE_DATADOG_PROVIDER_APP_ID),
  clientToken: returnString(import.meta.env.VITE_DATADOG_CLIENT_TOKEN),
  site: 'datadoghq.com',
  service: returnString(import.meta.env.VITE_DATADOG_APP_NAME),
  env: returnString(import.meta.env.VITE_ENVIRONMENT),
  version: returnString(import.meta.env.VITE_BUILD_VERSION, 'localhost'),
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  allowedTracingUrls: [
    /(https:|http:)*\/\/(localhost:3000|api\.(qa-|stage-|production-)*insights.restoreskills.com)/
  ],
});


initFullStory({ orgId: 'o-21YY1Y-na1' });

FS('start')

root.render(
  <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Suspense>
          <ReduxProvider store={reduxStore}>
            <ReduxPersist
              loading={null}
              persistor={persistor}
            >
              <App />
            </ReduxPersist>
            <Intercom />
          </ReduxProvider>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  </HelmetProvider>
);
